export default{	
	
	home :{
		es :{
			title : "Aldonza | Productos gourmet que despiertan sensaciones",
			description : "Vino, cava, aceite de oliva y azafrán, productos gourmet españoles elaborados en la Dehesa de Navamarín. Bodega y almazara propia con visitas de enoturismo y oleoturismo. ¡Vive la experiencia Aldonza!"
		},
		en : {
			title : "Aldonza | Gourmet products that awaken the senses",
			description : "Wine, cava, olive oil and saffron, Spanish gourmet products made in the Dehesa de Navamarín. Own winery and mill with wine and oil tourism and visits. Live the Aldonza experience!"
		},
		ja : {
			title : "Aldonza | Gourmet products that awaken the senses",
			description : "Wine, cava, olive oil and saffron, Spanish gourmet products made in the Dehesa de Navamarín. Own winery and mill with wine and oil tourism and visits. Live the Aldonza experience!"
		},
		ru : {
			title : "Альдонза | Изысканные продукты, которые пробуждают впечатления",
			description : "Вино, кава, оливковое масло и шафран, испанские деликатесы, произведенные в Деэса-де-Навамарин. Собственная винодельня и мельница с посещением винного туризма и нефтяного туризма. Живите впечатлениями с Альдонза!"
		}
	},
	la_tierra :{
		es :{
			title : "Aldonza Gourmet | Bienvenido a la finca Dehesa de Navamarín",
			description : "Tierra de viñedos, olivos y azafranales con condiciones idóneas para el cultivo del vino, aceite de oliva y azafrán. Esencia de los productos Aldonza Gourmet elaborados en la finca Dehesa de Navamarín."
		},
		en : {
			title : "Aldonza Gourmet | Welcome to the Dehesa de Navamarín Estate",
			description : "The land of vineyards, olives and crocuses with ideal conditions for the cultivation of wine, olive oil and saffron. Essence of Aldonza Gourmet products made in the Dehesa de Navamarín estate."
		},
		ja : {
			title : "Aldonza Gourmet | Welcome to the Dehesa de Navamarín Estate",
			description : "The land of vineyards, olives and crocuses with ideal conditions for the cultivation of wine, olive oil and saffron. Essence of Aldonza Gourmet products made in the Dehesa de Navamarín estate."
		},
		ru : {
			title : "Альдонза Гурмэ | Добро пожаловать на ферму Деэса-де-Навамарин",
			description : "Территория виноградников, оливковых деревьев и шафрановых полей с идеальными условиями для выращивания сырья для вина, оливкового масла и шафрана. Эссенция продуктов Альдонза Гурмэ, произведенных на ферме Деэса-де-Навамарин."
		}
	},
	la_bodega :{
		es :{
			title : "Bodega exportadora de vino con tradición | Aldonza",
			description : "Bodega española familiar de Albacete, tierra de Don Quijote. Tradición agrícola e innovación para elaborar vinos que despiertan nuevas sensaciones. ¡Descubre nuestras jornadas de enoturismo!"
		},
		en : {
			title : "Traditional wine exporter | Aldonza",
			description : "Spanish family winery in Albacete, the land of Don Quijote. Agricultural tradition and innovation to make wines that awaken new sensations. Discover our wine tourism days!"
		},
		ja : {
			title : "Traditional wine exporter | Aldonza",
			description : "Spanish family winery in Albacete, the land of Don Quijote. Agricultural tradition and innovation to make wines that awaken new sensations. Discover our wine tourism days!"
		},
		ru : {
			title : "Винодельня экспортирует вино с традициями | Альдонза",
			description : "Испанская семейная винодельня из Альбасете, земли Дон Кихота. Сельскохозяйственные традиции и инновации для производства вин, пробуждающих новые ощущения. Откройте для себя наши экскурсии в  мир энотуризма!"
		}
	},
	queseria :{
		es :{
			title : "Bodega exportadora de vino con tradición | Aldonza",
			description : "Bodega española familiar de Albacete, tierra de Don Quijote. Tradición agrícola e innovación para elaborar vinos que despiertan nuevas sensaciones. ¡Descubre nuestras jornadas de enoturismo!"
		},
		en : {
			title : "Traditional wine exporter | Aldonza",
			description : "Spanish family winery in Albacete, the land of Don Quijote. Agricultural tradition and innovation to make wines that awaken new sensations. Discover our wine tourism days!"
		},
		ja : {
			title : "Traditional wine exporter | Aldonza",
			description : "Spanish family winery in Albacete, the land of Don Quijote. Agricultural tradition and innovation to make wines that awaken new sensations. Discover our wine tourism days!"
		},
		ru : {
			title : "Винодельня экспортирует вино с традициями | Альдонза",
			description : "Испанская семейная винодельня из Альбасете, земли Дон Кихота. Сельскохозяйственные традиции и инновации для производства вин, пробуждающих новые ощущения. Откройте для себя наши экскурсии в  мир энотуризма!"
		}
	},
	elaboracion_cava :{
		es :{
			title : "Método tradicional de elaboración de cava",
			description : "Conoce la elaboración del cava paso a paso. En Aldonza Gourmet, mantenemos vivo el método tradicional de elaboración de los vinos espumosos españoles."
		},
		en : {
			title : "Traditional cava production method",
			description : "Learn how cava is made, step by step. At Aldonza Gourmet, we keep the traditional method of making Spanish sparkling wines alive. "
		},
		ja : {
			title : "Traditional cava production method",
			description : "Learn how cava is made, step by step. At Aldonza Gourmet, we keep the traditional method of making Spanish sparkling wines alive. "
		},
		ru : {
			title : "Традиционный способ приготовления кавы",
			description : "Узнайте, как сделать каву шаг за шагом. В Альдонза Гурмэ мы сохраняем традиционный метод изготовления испанских игристых вин. "
		}
	},
	elaboracion_vino :{
		es :{
			title : "Elaboración del vino paso a paso",
			description : "El proceso de elaboración del vino con todas sus fases. Aldonza Gourmet extrae la grandeza de la uva para elaborar vinos de primera clase. ¡Conoce el proceso!index.js"
		},
		en : {
			title : "Wine production, step by step",
			description : "All stages of the wine making process. Aldonza Gourmet extracts the greatness from the grape to make first class wines. Come and see the process! "
		},
		ja : {
			title : "Wine production, step by step",
			description : "All stages of the wine making process. Aldonza Gourmet extracts the greatness from the grape to make first class wines. Come and see the process! "
		},
		ru : {
			title : "Пошаговое приготовление вина",
			description : "Процесс виноделия со всеми его этапами. Альдонза Гурмэ извлекает самое ценное из винограда для производства своих первоклассных вин. Узнай об этом процессе!"
		}
	},
	la_almanzara :{
		es :{
			title : "Almazara | Aldonza Gourmet",
			description : "Tradición familiar y tecnología. En nuestra almazara, trabajamos con delicadeza la aceituna para garantizar un aceite de oliva virgen extra de máxima calidad. ¡Estamos en la tierra de Don Quijote!"
		},
		en : {
			title : "Olive Press | Aldonza Gourmet",
			description : "Family tradition and technology. In our olive press, we work with the olives delicately to guarantee an extra virgin olive oil of the highest quality. We are in the land of Don Quijote!"
		},
		ja : {
			title : "Olive Press | Aldonza Gourmet",
			description : "Family tradition and technology. In our olive press, we work with the olives delicately to guarantee an extra virgin olive oil of the highest quality. We are in the land of Don Quijote!"
		},
		ru : {
			title : "Маслобойня | Альдонза Гурмэ",
			description : "Семейные традиции и технологии. На нашей мельнице мы деликатно обрабатываем оливки, чтобы гарантировать получение оливкового масла высшего качества. Мы же находимся в стране Дон Кихота!"
		}
	},
	elaboracion_aceite :{
		es :{
			title : "Elaboración del aceite de oliva",
			description : "Fases de la elaboración del aceite de oliva virgen extra. La tradición convive con la modernidad de la almazara Aldonza Gourmet para producir aceite de oliva de gran calidad."
		},
		en : {
			title : "Olive oil production",
			description : "Stages of extra virgin olive oil production. Tradition coexists with the modernity of the Aldonza Gourmet olive press to produce high quality olive oil. "
		},
		ja : {
			title : "Olive oil production",
			description : "Stages of extra virgin olive oil production. Tradition coexists with the modernity of the Aldonza Gourmet olive press to produce high quality olive oil. "
		},
		ru : {
			title : "Производство оливкового масла",
			description : "Этапы производства оливкового масла первого холодного отжима. Традиции мирно уживаются с современными тенденциями на заводе Альдонза Гурмэ для производства высококачественного оливкового масла."
		}
	},
	proceso_queso :{
		es :{
			title : "Elaboración del aceite de oliva",
			description : "Fases de la elaboración del aceite de oliva virgen extra. La tradición convive con la modernidad de la almazara Aldonza Gourmet para producir aceite de oliva de gran calidad."
		},
		en : {
			title : "Olive oil production",
			description : "Stages of extra virgin olive oil production. Tradition coexists with the modernity of the Aldonza Gourmet olive press to produce high quality olive oil. "
		},
		ja : {
			title : "Olive oil production",
			description : "Stages of extra virgin olive oil production. Tradition coexists with the modernity of the Aldonza Gourmet olive press to produce high quality olive oil. "
		},
		ru : {
			title : "Производство оливкового масла",
			description : "Этапы производства оливкового масла первого холодного отжима. Традиции мирно уживаются с современными тенденциями на заводе Альдонза Гурмэ для производства высококачественного оливкового масла."
		}
	},
	sala_azafran :{
		es :{
			title : "Azafranal de La Mancha | Azafrán Aldonza Gourmet",
			description : "En nuestros campos y modernas instalaciones, cultivamos, seleccionamos y envasamos artesanalmente el azafrán de hebra Aldonza. Con Denominación de Origen La Mancha."
		},
		en : {
			title : "La Mancha Saffron | Aldonza Gourmet Saffron",
			description : "On our fields and modern facilities, we grow, select and package Aldonza saffron strands in the traditional way. With La Mancha D.O. "
		},
		ja : {
			title : "La Mancha Saffron | Aldonza Gourmet Saffron",
			description : "On our fields and modern facilities, we grow, select and package Aldonza saffron strands in the traditional way. With La Mancha D.O. "
		},
		ru : {
			title : "Шафран из Ла-Манчи | Шафран Альдонза Гурмэ ",
			description : "На наших полях и в современных условиях мы выращиваем, отбираем и вручную упаковываем нитевидный шафран Альдонза D.P.O. Ла-Манча."
		}
	},
	elaboracion_azafran :{
		es :{
			title : "Proceso de elaboración del azafrán",
			description : "El proceso de elaboración del azafrán en hebras es tan delicado como los estigmas rojos de su flor. El azafrán Aldonza Gourmet se elabora respetando este trabajo milenario."
		},
		en : {
			title : "Saffron production process",
			description : "The saffron production process is as delicate as the red stigmas of its flower. Aldonza Gourmet saffron is made in keeping with this ancient work. "
		},
		ja : {
			title : "Saffron production process",
			description : "The saffron production process is as delicate as the red stigmas of its flower. Aldonza Gourmet saffron is made in keeping with this ancient work. "
		},
		ru : {
			title : "Процесс производства шафрана",
			description : "Процесс изготовления шафрановых нитей такой же тонкий, как и красные рыльца его цветка. Шафран Альдонза Гурмэ сделан с уважением к этой древней традиционной работе."
		}
	},
	productos :{
		es :{
			title : "Productos gourmet españoles | Aldonza Gourmet",
			description : "Vino, cava, aceite de oliva virgen extra y azafrán. Productos gourmet españoles con calidad y sabor, elaborados por Aldonza Gourmet en La Dehesa de Navamarín. ¡Despiertan nuevas sensaciones!"
		},
		en : {
			title : "Gourmet Spanish products | Aldonza Gourmet",
			description : "Wine, cava, extra virgin olive oil and saffron. Spanish gourmet products with quality and flavor, produced by Aldonza Gourmet in La Dehesa de Navamarín. Awaken new sensations! "
		},
		ja : {
			title : "Gourmet Spanish products | Aldonza Gourmet",
			description : "Wine, cava, extra virgin olive oil and saffron. Spanish gourmet products with quality and flavor, produced by Aldonza Gourmet in La Dehesa de Navamarín. Awaken new sensations! "
		},
		ru : {
			title : "Испанские деликатесы | Альдонза Гурмэ",
			description : "Вино, кава, оливковое масло первого холодного отжима и шафран. Испанские продукты для гурманов высокого качества с уникальным вкусом, произведенные Альдонза Гурмэ в Ла-Деэса-де-Навамарин. Пробуждение новых ощущений!"
		}
	},
	productos_ficha : {
		es : {
			aceite : {
				title : "Aceite de Oliva Virgen Extra | Aldonza Gourmet",
				description : "El aceite de oliva virgen extra Aldonza expresa todo el sabor de las varietales de aceituna Picual y Arbequina. 100% Virgen Extra. Exportación internacional. Es el resultado de la pasión por un oficio."
			},
			vino : {
				title : "Vinos que despiertan sensaciones | Aldonza Gourmet",
				description : "Vinos Aldonza Gourmet, la huella de la tradición vinícola de la tierra de Don Quijote.  Vinos con pasión, con alma. Elaborados a partir de varietales de uva francesa y española.  ¿Todavía no los conoces?"
			},
			azafran : {
				title : "Azafrán de La Mancha | Aldonza Gourmet",
				description : "Azafrán español con Denominación de Origen La Mancha, reconocimiento de calidad mundial. Azafrán en hebras Aldonza Gourmet, pequeños detalles que marcan la diferencia."
			},
			cava : {
				title : "Cavas con personalidad propia | Aldonza Gourmet",
				description : "Levaduras propias y seleccionadas con rigor que otorgan personalidad propia a las cuatro variedades de vinos espumosos Aldonza Gourmet. Cava con D.O. Vinos Espumosos, cultivado en la comarca del Penedés."
			},
		},
		en :{
			wine : {
				title : "Wines that awaken the senses | Aldonza Gourmet",
				description : "Aldonza Gourmet wines, the legacy of wine tradition in the land of Don Quijote.  Wines with passion, with soul. Made from French and Spanish grape varietals.  You still don't know them?"
			},
			oil : {
				title : "Extra Virgen Olive Oil | Aldonza Gourmet ",
				description : "Aldonza extra virgin olive oil expresses all the flavor of Picual and Arbequina olive varieties. 100% Extra Virgen. Exported internationally. It is the result of passion for a trade."
			},
			saffron : {
				title : "La Mancha Saffron | Aldonza Gourmet",
				description : "Spanish saffron with La Mancha D.O., a worldwide quality recognition. Aldonza Gourmet Saffron strands, small details that make the difference."
			},
			cava : {
				title : "Cava with its own character | Aldonza Gourmet",
				description : "Own and rigorously selected yeasts that give the four Aldonza Gourmet sparkling wines their own personality. Cava with D.O. Sparkling wines, grown in the Penedés region."
			}
		},
		ja :{
			wine : {
				title : "Wines that awaken the senses | Aldonza Gourmet",
				description : "Aldonza Gourmet wines, the legacy of wine tradition in the land of Don Quijote.  Wines with passion, with soul. Made from French and Spanish grape varietals.  You still don't know them?"
			},
			oil : {
				title : "Extra Virgen Olive Oil | Aldonza Gourmet ",
				description : "Aldonza extra virgin olive oil expresses all the flavor of Picual and Arbequina olive varieties. 100% Extra Virgen. Exported internationally. It is the result of passion for a trade."
			},
			saffron : {
				title : "La Mancha Saffron | Aldonza Gourmet",
				description : "Spanish saffron with La Mancha D.O., a worldwide quality recognition. Aldonza Gourmet Saffron strands, small details that make the difference."
			},
			cava : {
				title : "Cava with its own character | Aldonza Gourmet",
				description : "Own and rigorously selected yeasts that give the four Aldonza Gourmet sparkling wines their own personality. Cava with D.O. Sparkling wines, grown in the Penedés region."
			}
		},
		ru : {
			aceite : {
				title : "Оливковое масло первого холодного отжима | Альдонза Гурмэ ",
				description : "Оливковое масло первого холодного отжима Альдонза выражает весь вкус оливок сортов пикуаль и арбекина. 100% Экстра Вирджин. Международный экспорт. Наш продукт - результат страстного отношения к своему делу."
			},
			vino : {
				title : "Вина, которые впечатляют | Альдонза Гурмэ",
				description : "Вина Альдонза Гурмэ — наследие винодельческих традиций родины Дон Кихота. Вина, изготовленные со страстью и душой. Вырабатываются лучших сортов французского и испанского винограда. Все еще не знакомы с ними?"
			},
			azafran : {
				title : "Шафран из Ла-Манчи | Альдонза Гурмэ",
				description : "Знаменитый отборный испанский шафран из региона Ла-Манча, качество которого признано во всем мире. Шафрановые лепестки Альдонза Гурмэ, маленькие ароматные детали, которые придают оригинальность."
			},
			cava : {
				title : "Кава с оригинальным вкусом | Альдонза Гурмэ",
				description : "Отборные дрожжи собственного производства, которые придают индивидуальность четырем разновидностям игристых вин Альдонза Гурмэ. Кава высшей категории. Игристые вина премиум класса, произведенные в регионе Пенедес."
			},
		},
	},
	premios_ficha :{
		es : {
			aceite : {
				title : "Premios del aceite de oliva | Aldonza Gourmet",
				description : "El aceite de oliva virgen extra Aldonza Gourmet está avalado por reconocimientos internacionales en diversos certámenes de aceite de oliva."
			},
			vino : {
				title : "Premios del vino | Aldonza Gourmet",
				description : "Premios del vino. Los vinos tintos y el vino blanco Aldonza Gourmet han sido reconocidos con premios internacionales y críticas de los mejores sumillers."
			},
			azafran : {
				title : "Azafrán de La Mancha | Aldonza Gourmet",
				description : "Azafrán español con Denominación de Origen La Mancha, reconocimiento de calidad mundial. Azafrán en hebras Aldonza Gourmet, pequeños detalles que marcan la diferencia."
			},
			cava : {
				title : "Cava con premio | Aldonza Gourmet",
				description : "Los cavas Aldonza Gourmet son vinos espumosos reconocidos internacionalmente por prestigiosos premios. Consulta aquí lista."
			},
		},
		en : {
			wine : {
				title : "Wine awards | Aldonza Gourmet ",
				description : "Wine awards. Aldonza Gourmet red and white wines have been recognized internationally with awards and reviews from the best sommeliers. "
			},
			oil : {
				title : "Olive oil awards | Aldonza Gourmet  ",
				description : "Aldonza Gourmet extra virgin olive oil is backed by international recognition from various olive oil competitions. "
			},
			saffron : {
				title : "",
				description : ""
			},
			cava : {
				title : "Award winning cava | Aldonza Gourmet",
				description : "Aldonza Gourmet cavas are sparkling wines with international recognition and awards. See the list here.  "
			}
		},
		ja :{
			wine : {
				title : "Wine awards | Aldonza Gourmet ",
				description : "Wine awards. Aldonza Gourmet red and white wines have been recognized internationally with awards and reviews from the best sommeliers. "
			},
			oil : {
				title : "Olive oil awards | Aldonza Gourmet  ",
				description : "Aldonza Gourmet extra virgin olive oil is backed by international recognition from various olive oil competitions. "
			},
			saffron : {
				title : "",
				description : ""
			},
			cava : {
				title : "Award winning cava | Aldonza Gourmet",
				description : "Aldonza Gourmet cavas are sparkling wines with international recognition and awards. See the list here.  "
			}
		},
		ru : {
			aceite : {
				title : "Награды оливкового масла | Альдонза Гурмэ",
				description : "Оливковое масло первого холодного отжима Альдонза Гурмэ получило международное признание на различных конкурсах оливкового масла."
			},
			vino : {
				title : "Награды наших вин | Альдонза Гурмэ",
				description : "Премии наших вин. Красные вина и белое вино Альдонза Гурмэ были отмечены международными наградами и исключительными отзывами лучших сомелье."
			},
			azafran : {
				title : "Шафран из Ла-Манчи | Альдонза Гурмэ",
				description : "Настоящий отборный испанский шафран из Ла-Манчи, признанный во всем мире. Лепестки сушеного шафрана Альдонза Гурмэ, маленькие детали, придающие идеальный вкус."
			},
			cava : {
				title : "Кава высшего качества | Альдонза Гурмэ",
				description : "Кава Альдонза Гурмэ — это игристые вина, высокое качество которых признано во всем мире престижными наградами. Полный ассортимент здесь."
			},
		},
	},
	beneficios_ficha :{
		es : {
			aceite : {
				title : "Beneficios del aceite del oliva | Propiedades para la salud",
				description : "Sabor y bienestar. Descubre los beneficios y las propiedades que el consumo diario del aceite de oliva virgen extra aporta a tu salud."
			},
			vino : {
				title : "Beneficios del vino | Propiedades para la salud ",
				description : "El consumo moderado del vino aporta una amplía lista de beneficios y propiedades para la salud. En esta lista puedes consultar las cualidades del vino."
			},
			azafran : {
				title : "Beneficios del azafrán | Propiedades para la salud",
				description : "Mucho más que una especia. Aquí tienes el listado de los beneficios y propiedades del azafrán. Respaldado por estudios científicos."
			},
			cava : {
				title : "Beneficios del cava | Propiedades para la salud",
				description : "Descubre los beneficios del cava para la salud. Mucho más que sabor y burbujas. Consulta aquí la lista de propiedades del cava."
			},
		},
		en : {
			wine : {
				title : "Wine benefits | Health properties",
				description : "Moderate consumption of wine provides an extensive list of health benefits and properties. This list shows you the qualities of the wine. "
			},
			oil : {
				title : "Olive oil benefits | Health properties ",
				description : "Taste and well-being. Discover the health benefits and properties from the daily consumption of extra virgin olive oil. "
			},
			saffron : {
				title : "Saffron benefits | Health properties",
				description : "Much more than just a spice. Here is the list of the benefits and properties of saffron. Backed by scientific studies."
			},
			cava : {
				title : "Cava benefits | Health properties",
				description : "Discover the health benefits of cava. Much more than just taste and bubbles. See the list of properties of cava here."
			}
		},
		ja :{
			wine : {
				title : "Wine benefits | Health properties",
				description : "Moderate consumption of wine provides an extensive list of health benefits and properties. This list shows you the qualities of the wine. "
			},
			oil : {
				title : "Olive oil benefits | Health properties ",
				description : "Taste and well-being. Discover the health benefits and properties from the daily consumption of extra virgin olive oil. "
			},
			saffron : {
				title : "Saffron benefits | Health properties",
				description : "Much more than just a spice. Here is the list of the benefits and properties of saffron. Backed by scientific studies."
			},
			cava : {
				title : "Cava benefits | Health properties",
				description : "Discover the health benefits of cava. Much more than just taste and bubbles. See the list of properties of cava here."
			}
		},
		ru : {
			aceite : {
				title : "Преимущества оливкового масла | Целебные свойства.",
				description : "Вкус и польза для здоровья. Узнайте для себя полезные свойства и уникальные качества оливкового масла Экстра Вирджин, а также те положительные изменения для здоровья, которые приносит его ежедневное употребление. "
			},
			vino : {
				title : "Уникальные свойства вина | Польза для здоровья",
				description : "Умеренное употребление вина обеспечивает широкий спектр преимуществ и полезных свойств для здоровья. Здесь вы можете ознакомиться с этими свойствами  вина."
			},
			azafran : {
				title : "Польза шафрана | Целебные свойства",
				description : "Гораздо больше, чем просто специя. Вот список полезных качеств и свойств шафрана. Подтверждено научными исследованиями."
			},
			cava : {
				title : "Полезные особенности кавы | Преимущества для здоровья",
				description : "Узнайте о пользе кавы для здоровья. Это намного больше, чем вкус и пузырьки. Проверьте здесь список полезных свойств кавы. "
			},
		},
	},
	vive_aldonza:{
		es :{
			title : "La experiencia Aldonza | Más que enoturismo y oleoturismo",
			description : "Enoturismo, oleoturismo, escapadas rurales, cursos de cocina, recetarios y mucho más. Tu experiencia Aldonza Gourmet empieza aquí. Vive momentos únicos."
		},
		en : {
			title : "The Aldonza experience | More than just wine and oil tourism",
			description : "Wine tourism, oil tourism, rural getaways, cooking courses, cookbooks and much more. Your Aldonza Gourmet experience begins here. Have unique experiences. "
		},
		ja : {
			title : "The Aldonza experience | More than just wine and oil tourism",
			description : "Wine tourism, oil tourism, rural getaways, cooking courses, cookbooks and much more. Your Aldonza Gourmet experience begins here. Have unique experiences. "
		},
		ru :{
			title : "Путешествие в Альдонзу | Больше, чем просто гастрономический туризм",
			description : "Винный туризм, олеотуризм, дегустации оливкового масла, агротуризм, кулинарные курсы, книги рецептов и многое другое. Ваше знакомство с Альдонза Гурмэ начинается здесь. Живите уникальными моментами."
		}
	},
	oleoturismo:{
		es :{
			title : "Oleoturismo | Aceite de Oliva Virgen Extra Aldonza",
			description : "Oleoturismo en La Mancha. Un viaje al mundo del aceite de oliva virgen extra en la almazara Aldonza Gourmet. ¡Reserva tu visita! Cata profesional del producto."
		},
		en : {
			title : "Olive tourism | Aldonza Extra Virgen Olive Oil ",
			description : "Oil tourism in La Mancha. A trip through the world of extra virgin olive oil in the Aldonza Gourmet olive press. Book your visit! Professional tasting of the product."
		},
		ja : {
			title : "Olive tourism | Aldonza Extra Virgen Olive Oil ",
			description : "Oil tourism in La Mancha. A trip through the world of extra virgin olive oil in the Aldonza Gourmet olive press. Book your visit! Professional tasting of the product."
		},
		ru :{
			title : "Олеотуризм | Оливковое масло Экстра Вирджин Альдонза",
			description : "Олеотуризм в Ла-Манче. Путешествие в мир оливкового масла первого холодного отжима на фабрике Альдонза Гурмэ. Забронируйте визит! Профессиональная дегустация продукта."
		}
	},
	
	ruta_cervantina:{
		es :{
			title : "Don Quijote de La Mancha | Ruta Cervantina | Aldonza",
			description : "Escapadas rurales por los mismos lugares que pasó Don Quijote de La Mancha. Una ruta cervantina apasionante con parada en las bodega y almazara Aldonza Gourmet. ¡Vive la experiencia!"
		},
		en : {
			title : "Don Quijote de La Mancha | Route of Cervantes | Aldonza ",
			description : "Rural getaways through the same places visited by Don Quijote de La Mancha. An exciting Cervantes route with stops at the winery and Aldonza Gourmet oil press. Live the experience!"
		},
		ja : {
			title : "Don Quijote de La Mancha | Route of Cervantes | Aldonza ",
			description : "Rural getaways through the same places visited by Don Quijote de La Mancha. An exciting Cervantes route with stops at the winery and Aldonza Gourmet oil press. Live the experience!"
		},
		ru :{
			title : "Дон Кихот Ламанчский | Маршрут Сервантеса | Альдонза",
			description : "Сельский отдых по тем же местам, через которые прошел Дон Кихот Ламанчский. Захватывающий маршрут Сервантеса с остановкой на винодельне и мельнице Альдонза Гурмэ. Получите захватывающий опыт!"
		}
	},
	enoturismo:{
		es :{
			title : "Enoturismo en España | Aldonza Gourmet",
			description : "Enoturismo en La Mancha. Aldonza Gourmet te invita a vivir una experiencia inolvidable entre viñedos y en su bodega. Degustación de vinos en la sala de barricas. Solicita más información."
		},
		en : {
			title : "Wine tourism in Spain | Aldonza Gourmet",
			description : "Wine tourism in La Mancha. Aldonza Gourmet invites you to have an unforgettable experience among the vineyards and its winery. Wine tasting in the barrel room. Request more information. "
		},
		ja : {
			title : "Wine tourism in Spain | Aldonza Gourmet",
			description : "Wine tourism in La Mancha. Aldonza Gourmet invites you to have an unforgettable experience among the vineyards and its winery. Wine tasting in the barrel room. Request more information. "
		},
		ru :{
			title : "Винный туризм в Испании | Альдонза Гурмэ",
			description : "Винный туризм в Ла-Манче. Альдонза Гурмэ приглашает вас получить незабываемые впечатления среди виноградников и на фабрике вин. Дегустация бочковых вин. Запросить дополнительную информацию."
		}
	},
	recetario:{
		es :{
			title : "Recetas Aldonza Gourmet | Ruta gastronómica",
			description : "Clásicas o modernas pero elaboradas con productos de la tierra. Descubre el recetario online y la ruta gastronómica de Aldonza Gourmet."
		},
		en : {
			title : "Aldonza Gourmet Recipes | Gastronomic route",
			description : "Classic or modern but made with local products. Discover the online recipe book and the gastronomic route of Aldonza Gourmet. "
		},
		ja : {
			title : "Aldonza Gourmet Recipes | Gastronomic route",
			description : "Classic or modern but made with local products. Discover the online recipe book and the gastronomic route of Aldonza Gourmet. "
		},
		ru :{
			title : "Рецепты для гурманов Альдонза | Гастрономический маршрут",
			description : "Классические или современные, но приготовленные из местных продуктов. Откройте для себя онлайн-книгу рецептов и гастрономический маршрут Альдонза Гурмэ."
		}
	},
	escucha_aldonza:{
		es :{
			title : "Música y vino | Escucha Aldonza Gourmet",
			description : "Música, vino o cualquier otro producto. Aldonza Gourmet te invita a sentir una nueva experiencia sensorial mientras degustas una copa de vino. ¡Dale al play!"
		},
		en : {
			title : "Music and wine | Listen to Aldonza Gourmet",
			description : "Music, wine or any other product. Aldonza Gourmet invites you to a new sensory experience while tasting a glass of wine. Press play!"
		},
		ja : {
			title : "Music and wine | Listen to Aldonza Gourmet",
			description : "Music, wine or any other product. Aldonza Gourmet invites you to a new sensory experience while tasting a glass of wine. Press play!"
		},
		ru :{
			title : "Музыка и вино | Слушай Альдонза Гурмэ",
			description : "Музыка, вино или любой другой продукт. Альдонза Гурмэ приглашает вас ощутить новые чувственные впечатления за бокалом вина. Нажми и слушай!"
		}
	},
	contacto :{
		es :{
			title : "Aldonza Gourmet | Vinos, cavas, aceite de oliva y azafrán",
			description : "Atención personalizada sobre la venta y exportación de nuestros productos. Visitas guiadas de enoturismo y oleoturismo organizadas en la bodega y almazara Aldonza Gourmet. ¡Contacta con nosotros!"
		},
		en : {
			title : "Aldonza Gourmet | Wines, cava, olive oil and saffron",
			description : "Personalized attention on the sale and export of our products. Guided tours of wine and oil tourism organized in the Aldonza Gourmet winery and olive press. Contact us!"
		},
		ja : {
			title : "Aldonza Gourmet | Wines, cava, olive oil and saffron",
			description : "Personalized attention on the sale and export of our products. Guided tours of wine and oil tourism organized in the Aldonza Gourmet winery and olive press. Contact us!"
		},
		ru :{
			title : "Альдонза Гурмэ | Вина, кава, оливковое масло и шафран",
			description : "Индивидуальный подход к продаже и экспорту нашей продукции. Экскурсии с гидом по винному маршруту и олеотуризм, организованные на винодельне и масличной мельнице Альдонза Гурмэ. Свяжитесь с нами!"
		}
	},
	politica_privacidad :{
		es :{
			title : "",
			description : ""
		},
		en : {
			title : "",
			description : ""
		},
		ja : {
			title : "",
			description : ""
		},
		ru :{
			title : "",
			description : ""
		}
	},
	politica_cookies :{
		es :{
			title : "",
			description : ""
		},
		en : {
			title : "",
			description : ""
		},
		ja : {
			title : "",
			description : ""
		},
		ru :{
			title : "",
			description : ""
		}
	},
}




// WEBPACK FOOTER //
// ./src/translations/seo.js